import { assertNever } from '@/helpers/utils';

export const SELECTABLE_VEHICLE_AMOUNT_PER_AREA = {
  MIN: 1,
  MAX: 1,
};

// used on floorplan level and shape level // id constructed based on vehicle name upon retrieval from pim api
export const DEFAULT_ENABLED_VEHICLE_TYPE_IDS = ['SAE160_1200_triplex_rear'];

// TODO: derive this this data from PIM core
export const LOAD_CARRIERS_CARRIABLE_BY_SHUTTLES_IDS = [
  'EPAL_1',
  'EPAL_2',
  'WP',
  'WPASIA',
  'P1208B',
  'P1208A',
];
export const SHUTTLE_LOAD_CARRIERS_IDS = ['RS150_800', 'RS150_1000'];
export const VEHICLES_ABLE_TO_CARRY_SHUTTLES_NAMES = [
  'RAE160_1200_triplexb_rear',
  'RAE250_1200_triplexc_rear',
];
export const getValidShuttleLoadCarriers = (
  vehicleId: 'RS150_800' | 'RS150_1000',
): 'RS150_800' | 'RS150_1000' => {
  switch (vehicleId) {
    case 'RS150_800':
      return 'RS150_800';
    case 'RS150_1000':
      return 'RS150_1000';
    default:
      assertNever(vehicleId);
  }
};

export const LASSIE_PICKING_VEHICLE_NAMES = ['LPV_none'];
export const LASSIE_TRANSPORT_VEHICLE_NAMES = ['LTV_none'];

export const HIK_PICKING_VEHICLE_NAMES = ['CTU_DT'];
export const HIK_TRANSPORT_VEHICLE_NAMES = ['LMR_Q1P_50CE1'];
